'use strict';

var MarketIndicatorsBoxDirective = function MarketIndicatorsBoxDirective() {
  return {
    restrict: 'E',
    controller: 'MarketIndicatorsBoxController',
    template: require('../templates/market-indicators-box.html')
  };
};
MarketIndicatorsBoxDirective.$inject = [];
module.exports = MarketIndicatorsBoxDirective;